import customAxios from "../../customAxios";
import { UPDATE_CLIENT, UPDATE_WORK_TIME } from "../../routes";
import { ICreateAndUpdateWorkTime } from "../../../types/workTime.interface";

const updateWorkTime = async (props: ICreateAndUpdateWorkTime) => {
  const body: ICreateAndUpdateWorkTime = {
    dayName: props?.dayName,
    startTime: props?.startTime,
    endTime: props?.endTime,
    dayNumber: props?.dayNumber,
  };

  try {
    return (await customAxios.put(UPDATE_WORK_TIME + `/${props._id}`, body))
      .data;
  } catch (error: unknown) {
    console.error({ UPDATE_WORK_TIME: error });
    return false;
  }
};

export default updateWorkTime;
